/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const form = {
  formId: "new-platform-form",
  formField: {
    platformName: {
      name: "platformName",
      label: "Platform Name *",
      type: "text",
      placeholder: "eg. testplatform.gr",
      errorMsg: "Platform name is required.",
    },
    platformExchange: {
      name: "platformExchange",
      label: "Platform Exchange Name *",
      type: "text",
      placeholder: "eg. testplatform-gr",
      errorMsg: "Platform Exchange name is required.",
    },
    vlcourtEmail: {
      name: "vlcourtEmail",
      label: "Virtual Court Email *",
      type: "text",
      placeholder: "eg. test@skill90.io",
      errorMsg: "Virtual Court Email is required.",
    },
    vlcourtPassword: {
      name: "vlcourtPassword",
      label: "Virtual Court Password *",
      type: "text",
      placeholder: "eg. dfgf34s5h23",
      errorMsg: "Virtual Court Password is required.",
    },
    queueIdentifier: {
      name: "queueIdentifier",
      label: "Queue Identifier *",
      type: "text",
      placeholder: "eg. test",
      errorMsg: "Queue Identifier is required.",
    },
    routingKey: {
      name: "routingKey",
      label: "Routing Key",
      type: "text",
      placeholder: "eg. feed.{{eventType}}.{{sportId}}.{{sportId}}",
      errorMsg: "Routing Key is required.",
    },
    rmqsSelected: {
      name: "rmqsSelected",
      label: "List of enabled RMQs *",
      type: "multiselect",
      placeholder: "eg. test",
      errorMsg: "List of selected RMQs is required.",
    },
    settleOnlyBets: {
      name: "settleOnlyBets",
      label: "Settle only Platform Bets ",
      type: "checkbox",
    },
    validateBets: {
      name: "validateBets",
      label: "Validate Platform Bets ",
      type: "checkbox",
    },
    receiveSeperateStatistics: {
      name: "receiveSeperateStatistics",
      label: "Receive Seperate Statistics ",
      type: "checkbox",
    },
    riskManagement: {
      name: "riskManagement",
      label: "Risk Management",
      type: "checkbox",
    },
    demo: {
      name: "demo",
      label: "Demo Feed",
      type: "checkbox",
    },
    hardProviderDown: {
      name: "hardProviderDown",
      label: "Hard Provider Down",
      type: "checkbox",
    },
    nuRemove: {
      name: "nuRemove",
      label: "NU Remove",
      type: "checkbox",
    },
    compressMessage: {
      name: "compressMessage",
      label: "compress Message",
      type: "checkbox",
    },
    traderView: {
      name: "traderView",
      label: "Trader View",
      type: "checkbox",
    },
    promos: {
      name: "promos",
      label: "Promos",
      type: "checkbox",
    },
    outrights: {
      name: "outrights",
      label: "Outright Fixtures",
      type: "select",
    },
  },
};

export default form;
